(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page"]) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    const productField = document.querySelector('[data-contact-product]');
    if (product && productField && !productField.value) {
      productField.value = product.replaceAll('-', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lest-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-lest-home]');
    roots.forEach((root) => {
      const carousel = root.querySelector('[data-lest-carousel]');
      if (carousel) {
        const slides = carousel.querySelectorAll('[data-lest-slide]');
        const buttons = carousel.querySelectorAll('[data-lest-slide-button]');
        let activeIndex = 0;
        let timer;

        const showSlide = (index) => {
          activeIndex = index;
          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
          buttons.forEach((button, buttonIndex) => {
            const active = buttonIndex === index;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        };

        const restart = () => {
          window.clearInterval(timer);
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            timer = window.setInterval(() => showSlide((activeIndex + 1) % slides.length), 7000);
          }
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            showSlide(Number(button.dataset.lestSlideButton));
            restart();
          });
        });
        carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
        carousel.addEventListener('mouseleave', restart);
        restart();
      }

      const tabs = root.querySelectorAll('[data-lest-tab]');
      const panels = root.querySelectorAll('[data-lest-panel]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.lestTab;
          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            const active = panel.dataset.lestPanel === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lest-main-product"]) return;
  try {
    
  document.querySelectorAll('[data-lest-product]').forEach((root) => {
    const thumbnails = root.querySelectorAll('[data-lest-media-target]');
    thumbnails.forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('.lest-pdp__media-list > figure').forEach((item) => {
          item.hidden = item.id !== button.dataset.lestMediaTarget;
        });
        thumbnails.forEach((item) => item.classList.toggle('is-active', item === button));
      });
    });

    const radios = root.querySelectorAll('.lest-pdp__options input');
    const select = root.querySelector('.lest-pdp__variant-select');
    const price = root.querySelector('[data-lest-price]');
    const comparePrice = root.querySelector('[data-lest-compare-price]');
    const addButton = root.querySelector('.lest-pdp__form > button[name="add"]');
    const stickyPrice = root.querySelector('[data-lest-sticky-price]');
    const stickyButton = root.querySelector('[data-lest-sticky-submit]');
    const stickyCart = root.querySelector('[data-lest-sticky-cart]');

    const syncVariant = () => {
      if (!select) return;
      const selections = Array.from(root.querySelectorAll('.lest-pdp__options input:checked')).map((input) => input.value);
      const match = Array.from(select.options).find((option) => {
        const values = JSON.parse(option.dataset.options || '[]');
        return values.every((value, index) => value === selections[index]);
      });
      if (!match) return;

      select.value = match.value;
      if (price) price.textContent = match.dataset.price;
      if (stickyPrice) stickyPrice.textContent = match.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = match.dataset.comparePrice;
        comparePrice.hidden = !match.dataset.comparePrice;
      }
      const available = match.dataset.available === 'true';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', syncVariant);
    });

    if (stickyButton && addButton) stickyButton.addEventListener('click', () => addButton.click());
    if (stickyCart) {
      const updateStickyCart = () => stickyCart.classList.toggle('is-visible', window.scrollY > 760);
      updateStickyCart();
      window.addEventListener('scroll', updateStickyCart, {passive: true});
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
